<template>
  <div class="content">
    <p class="title">
        <el-breadcrumb separator-class="el-icon-arrow-right color3">
            <el-breadcrumb-item>系统管理</el-breadcrumb-item>
            <el-breadcrumb-item>角色管理</el-breadcrumb-item>
        </el-breadcrumb>
    </p>
    <div class="build-CURD">
      <div class="build-bar">
        <!-- <span>角色名：</span>
            <el-input placeholder="请输入您的角色名" v-model="tableDataName"></el-input>
            <el-select v-model="roleType" placeholder="请选择" style="margin-left:20px;">
              <el-option
                v-for="item in roleTypes"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
        <el-button type="primary" icon="el-icon-search" @click="doFilter">查询</el-button>-->
        <el-button type="primary" class="add-user" @click="addRow()">角色添加</el-button>
      </div>
      <div class="build-table">
        <el-table
          :default-sort="{prop: 'date', order: 'descending'}"
          :data="tableDataEnd"
          border
          height="100%"
          style="width: 100%;"
        >
          <template slot="empty">
            <p>{{dataText}}</p>
          </template>
          <el-table-column label="序号" width="80">
            <template slot-scope="scope">
              <span>{{ scope.row.index }}</span>
            </template>
          </el-table-column>
          <el-table-column label="角色名称">
            <template slot-scope="scope">
              <a>{{ scope.row.name}}</a>
            </template>
          </el-table-column>
          <!-- <el-table-column label="所属端">
            <template slot-scope="scope">
              <span>{{ scope.row.userTypeName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="所属组织">
            <template slot-scope="scope">
              <span>{{ scope.row.groupName }}</span>
            </template>
          </el-table-column> -->
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
              <el-button
                size="mini"
                type="primary"
                @click="handleUser(scope.$index, scope.row)"
              >配置用户</el-button>
              <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
            </template>
          </el-table-column>

          <!-- 新增窗口 -->
          <el-dialog
            :title="addTitle"
            :visible.sync="addFormVisible"
            center
            :append-to-body="true"
            :before-close="handleClose"
            :lock-scroll="false"
            class="add-form"
            width="700px"
          >
            <el-form
              :model="addForm"
              ref="addForm"
              label-width="100px"
              :label-position="labelPosition"
              :rules="rules"
            >
              <el-form-item label="角色名称：" prop="name">
                <el-input v-model="addForm.name" autocomplete="off"></el-input>
              </el-form-item>
              <!-- <el-form-item label="归属端：" prop="field" style="width:100%;" v-if="addForm.id==''">
                    <el-select v-model="addForm.userType" placeholder="请选择归属端" @change="getCurUserType">
                      <el-option
                        v-for="item in userTypes"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"></el-option>
                    </el-select>
              </el-form-item>-->
              <el-form-item label="归属端：" prop="field" style="width:100%;">
                <span>{{addForm.userTypeName}}</span>
              </el-form-item>
              <!-- <el-form-item label="所属机构：" prop="field" style="width:100%;" v-if="addForm.id==''">
                    <el-select v-model="addForm.groupId" placeholder="请选择所属机构" filterable >
                      <el-option
                        v-for="item in groups"
                        :key="item.groupId"
                        :label="item.groupName"
                        :value="item.groupId">
                      </el-option>
                    </el-select>
              </el-form-item>-->
              <el-form-item label="所属机构：" prop="field" style="width:100%;">
                <span>{{addForm.groupIdName}}</span>
              </el-form-item>
              <el-form-item label="角色授权：" prop="field" style="position: relative;width:100%">
                <div class="block" style="float:left;">
                  <p style="font-weight: bold;color: #114bef;">web端目录</p>
                  <el-tree
                    class="role-tree"
                    :data="treeData"
                    show-checkbox
                    accordion
                    ref="tree"
                    node-key="id"
                    @check="changeTree"
                    :default-checked-keys="checkData"
                    :props="defaultProps"
                  ></el-tree>
                </div>
                <div class="block" style="float:left;margin-left:100px;">
                  <p style="font-weight: bold;color: #114bef;">APP端目录</p>
                  <el-tree
                    class="role-tree"
                    :data="treeApp"
                    show-checkbox
                    accordion
                    ref="app"
                    node-key="id"
                    :default-checked-keys="checkApp"
                    :props="defaultProps"
                  ></el-tree>
                </div>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="addFormVisible = false">取 消</el-button>
              <el-button type="primary" @click="sumbitAddRow('addForm')">确 定</el-button>
            </div>
          </el-dialog>
        </el-table>

        <!-- 分页展示 -->
        <!-- <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[5, 10, 20, 50]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalItems"
              style="padding:10px"
        ></el-pagination>-->
        <!-- 人员配置 表格-->
        <el-dialog
          title="人员列表"
          :visible.sync="editFormVisible"
          center
          :append-to-body="true"
          :lock-scroll="false"
          width="60%"
        >
          <div style="margin-bottom: 10px;text-align: right;">
            <el-button type="primary" @click="addUserFun">添加用户</el-button>
          </div>
          <el-table :data="userData" height="300" border style="width: 100%">
            <el-table-column type="index" width="80" label="序号"></el-table-column>
            <el-table-column prop="name" label="姓名"></el-table-column>
            <el-table-column prop="username" label="用户名"></el-table-column>
            <el-table-column prop="idcard" label="身份证"></el-table-column>
            <el-table-column prop="createDate" label="配置时间"></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button size="mini" type="danger" @click="userDelete(scope.$index, scope.row)">删除</el-button>
              </template>
            </el-table-column>
            <el-dialog width="30%" title="人员配置" :visible.sync="innerVisible" append-to-body>
              <el-form
                :model="addUser"
                ref="addUser"
                label-width="100px"
                :label-position="labelPosition"
                :rules="rules1"
              >
                <el-form-item label="检索账号：" prop="username">
                  <el-input v-model="addUser.username" autocomplete="off" @blur="searchUser"></el-input>
                </el-form-item>
                <el-form-item label="姓名：">
                  <el-input v-model="addUser.name" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="身份证号：">
                  <el-input v-model="addUser.idcard" autocomplete="off"></el-input>
                </el-form-item>
              </el-form>
              <div slot="footer" class="dialog-footer">
                <el-button @click="innerVisible = false">取 消</el-button>
                <el-button type="primary" @click="sumbitAddUser('addUser')">确 定</el-button>
              </div>
            </el-dialog>
          </el-table>
        </el-dialog>
      </div>
    </div>
    <!-- </el-tab-pane> -->
    <!-- <el-tab-pane label="用户添加">配置管理</el-tab-pane> -->
    <!-- </el-tabs> -->
  </div>
</template>

<script>
import myHttp from '../../../untils/port.js'
import util from '../../../untils/util.js'
import base from '../../../untils/base'
export default {
  data() {
    return {
      labelPosition: 'right',
      addLoading: false,
      addForm: {
        //form表格属性
        id: '',
        name: '',
        userId: '',
        userType: '',
        groupId: '',
        menuIds: '',
        userTypeName: '',
        groupIdName: ''
      },
      addTitle: '', //弹出框标题
      // editForm: [],
      radio: 1,
      search: '',
      searchData: '',
      addFormVisible: false,
      editFormVisible: false, //人员配置弹出框
      roleType: '', //所选下拉框数据
      roleTypes: [
        //表格搜索下拉框数据
        {
          label: '请选择',
          value: ''
        }
      ],
      groups: [], //企业或者项目（根据所选端）
      treeData: [], //树形数据（web端）
      defaultProps: {
        //树形属性确认
        children: 'children',
        label: 'name'
      },
      checkData: [], //展示已经选中的内容，["id","id"]web端
      tableDataName: '',
      tableDataEnd: [],
      currentPage: 1,
      pageSize: 10,
      totalItems: 0,
      filterTableDataEnd: [],
      flag: false,
      userData: [], //人员配置列表
      innerVisible: false, //人员配置 弹出框添加
      addUser: {
        id: '',
        roleId: '',
        username: '',
        name: '',
        idcard: ''
      },
      allMenuList: [], //web端全部数据
      dataText: '数据加载中...',
      userTypes: [], //
      treeApp: [], //app端菜单tree
      checkApp: [], //app端已选菜单
      allMenuApp: [], //app端全部数据
      rules: {
        name: [{ required: true, message: '请输入角色名', trigger: 'blur' }]
      },
      rules1:{
        username: [{ required: true, message: '请输入用户名', trigger: 'blur' }]
      },
    }
  },
  created() {},
  mounted() {
    this.groupId = this.$store.state.groupId
    if ('' == this.groupId) {
      this.$store.commit('setGroupId')
      this.groupId = this.$store.state.groupId
    }
    this.getData()
    // this.getMenu();
    // this.getAppMenu()
    this.zidian()
  },
  methods: {
    // addDate() {
    //   nowDate = new Date()
    //   let date = {
    //     year: nowDate.getFullYear(),
    //     month: nowDate.getMonth() + 1,
    //     date: nowDate.getDate()
    //   }
    //   console.log(date)
    //   let systemDate = date.year + '-' + 0 + date.month + '-' + 0 + date.date
    // },
    //获取字典表
    zidian() {
      var that = this
      myHttp
        .getDictByType({
          type: 'user_type'
        })
        .then(function(resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.dictList || []
            for (var i = 0; i < list.length; i++) {
              that.roleTypes.push(list[i])
            }
            that.userTypes = list
          }
        })
    },
    // 搜索数据
    doFilter() {
      this.currentPage = 1
      this.currentChangePage()
      this.flag = true
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1
      this.handleCurrentChange(this.currentPage)
    },
    handleCurrentChange(val) {
      this.currentPage = val
      if (!this.flag) {
        this.currentChangePage()
      } else {
        this.currentChangePage()
      }
    },
    // 监控当前页码
    currentChangePage(list) {
      this.getData()
    },
    // 获取数据
    getData() {
      var option = {
        //name:this.tableDataName,
        userType: util.session.get('roleId'),
        groupId: this.groupId,
        userId: util.session.get('user').id
        // pageNum:this.currentPage,
        // pageSize:this.pageSize
      }
      var that = this
      //myHttp.getRoleListByGroupId(option).then(
      myHttp.getRoleByGroup(option).then(
        function(resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.role || []
            for (var i = 0; i < list.length; i++) {
              //list[i].index = ((that.currentPage - 1) * that.pageSize)+(i+1);
              list[i].index = i + 1
            }
            that.tableDataEnd = list
            //that.totalItems = resp.data.data.pageInfo.total||0;
            if (that.tableDataEnd.length == 0) {
              that.dataText = '暂无数据'
            }
          } else {
            that.$message.error(resp.data.msg)
            that.dataText = '暂无数据'
          }
        },
        function() {}
      )
    },
    //修改所属端获取企业或者项目
    getCurUserType(data) {
      this.addForm.groupId = ''
      this.getMenu(data)
      this.getGroup(data)
      // if(data==3||data==5){
      //   this.getEnt('');
      // }else if(data==4){
      //   this.getProject('');
      // }else if(data==2){
      //   this.getSuperList('');
      // }
    },
    //获取机构
    getGroup(port) {
      var that = this
      myHttp
        .getGroupListByUsePlat({
          userType: port
        })
        .then(function(resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.list || []
            that.groups = list
            that.addForm.groupIdName = that.getGrounpName(that.addForm.groupId)
            that.addForm.userTypeName = that.getUserTypeName(
              that.addForm.userType
            )
          } else {
            that.$message.error(resp.data.msg)
          }
        })
    },
    //获取企业
    // getEnt(name){
    //     var that = this;
    //     myHttp.getAllEnt({
    //       name:name
    //     }).then(function(resp){
    //         if(resp.data.code=="200"){
    //             var list = resp.data.data.entList;
    //             that.groups = list;
    //             that.addForm.groupIdName = that.getGrounpName(that.addForm.groupId),
    //             that.addForm.userTypeName = that.getUserTypeName(that.addForm.userType)
    //         }else{
    //           that.$message.error(resp.data.msg);
    //         }
    //     },function(){});
    // },
    //获取项目
    // getProject(name){
    //     var that = this;
    //     myHttp.getProjectPage({
    //       pageNum:1,
    //       pageSize:1000,
    //       name:name
    //     }).then(function(resp){
    //       if(resp.data.code=="200"){
    //          var list = resp.data.data.pageInfo.list;
    //          that.groups = list;
    //          that.addForm.groupIdName = that.getGrounpName(that.addForm.groupId),
    //          that.addForm.userTypeName = that.getUserTypeName(that.addForm.userType)
    //       }else{
    //         that.$message.error(resp.data.msg);
    //       }
    //     },function(){});
    // },
    //获取监管
    // getSuperList(name){
    //   var that = this;
    //   myHttp.getSuperviseAll({
    //     name:name
    //   }).then(function(resp){
    //     if(resp.data.code=="200"){
    //          var list = resp.data.data.supList;
    //          that.groups = list;
    //          that.addForm.groupIdName = that.getGrounpName(that.addForm.groupId),
    //          that.addForm.userTypeName = that.getUserTypeName(that.addForm.userType)
    //       }else{
    //         that.$message.error(resp.data.msg);
    //       }
    //   },function(){});
    // },
    // remoteMethod(data){
    //   if(this.addForm.userType==3){
    //     this.getEnt(data);
    //   }else if(this.addForm.userType==4){
    //     this.getProject(data);
    //   }
    // },
    //获取所有菜单
    getMenu(port) {
      this.allMenuList = []
      this.allMenuApp = []
      var that = this
      var userId = this.$store.state.user.id
      myHttp
        .getRoleMenuListByUserId({
          userId: userId,
          userType: port,
          roleId: this.addForm.id,
          groupId:this.groupId
        })
        .then(function(resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.allMenus || []
            var tree = util.common.listToTree('id', 'parentId', list)
            that.treeData = tree
            that.allMenuList = tree

            var listApp = resp.data.data.allMenusApp || []
            var treeApp = util.common.listToTree('id', 'parentId', listApp)
            that.treeApp = treeApp
            that.allMenuApp = treeApp

            var list1 = resp.data.data.selectMenus || []
            var list2App = resp.data.data.selectMenusApp || []

            if (list1.length > 0 || list2App.length > 0) {
              var menu = that.getChild(list1, list)
              var menuApp = that.getChild(list2App, listApp)
              //web端
              // var tree = util.common.listToTree('id','parentId',that.allMenuList);
              // that.treeData = tree;
              that.checkData = []
              for (var i = 0; i < menu.length; i++) {
                if(menu[i]){
                that.checkData.push(menu[i].id)

                }
              }
              //APP端
              // var treeApp = util.common.listToTree('id','parentId',that.allMenuApp);
              // that.treeApp = treeApp;
              that.checkApp = []
              for (var i = 0; i < menuApp.length; i++) {
                that.checkApp.push(menuApp[i].id)
              }
            }
          } else {
            that.$message.error(resp.data.msg)
          }
        })
    },
    //获取菜单
    // getMenu(){
    //     var that = this;
    //     var userId = this.$store.state.user.id;
    //     myHttp.getMenuAdmin({
    //       userId:userId
    //     }).then(function(resp){
    //       if(resp.data.code=="200"){
    //           var list = resp.data.data;
    //           var tree = util.common.listToTree('id','parentId',list);
    //           that.treeData = tree;
    //           that.allMenuList = tree;
    //       }else{
    //           that.$message.error(resp.data.msg);
    //       }
    //     },function(){});
    // },
    //获取app菜单 treeData1
    // getAppMenu(){
    //   var that = this;
    //   var userId = this.$store.state.user.id;
    //   myHttp.getMenuAppPageList({
    //     userId:userId
    //   }).then(function(resp){
    //     if(resp.data.code=="200"){
    //         var list = resp.data.data;
    //         var tree = util.common.listToTree('id','parentId',list);
    //         that.treeApp = tree;
    //         that.allMenuApp = tree;
    //     }else{
    //         that.$message.error(resp.data.msg);
    //     }
    //   },function(){});
    // },
    // 判断是否有子集
    getChild(select, all) {
      var result = []
      for (var i = 0; i < select.length; i++) {
        for (var j = 0; j < all.length; j++) {
          if (select[i].id == all[j].parentId ) {
            delete select[i]
            break
          }
        }
      }
      for (var k = 0; k < select.length; k++) {
        if (select[k] != undefined) {
          result.push(select[k])
        }
      }
      return result
    },
    // 编辑数据
    handleEdit(index, row) {
      this.addTitle = '角色修改'
      var that = this
      var userId = this.$store.state.user.id
      myHttp
        .getRoleById({
          id: row.id,
          userId: userId
        })
        .then(
          function(resp) {
            if (resp.data.code == '200') {
              that.addFormVisible = true
              var data = resp.data.data.role
              // var menu = resp.data.data.selectMenus;
              // console.log(that.getChild(menu,resp.data.data.allMenus))
              // var menu = that.getChild(resp.data.data.selectMenus,resp.data.data.allMenus);
              // var menuApp = that.getChild(resp.data.data.selectMenusApp,resp.data.data.allMenusApp);

              that.addForm = {
                id: data.id,
                userId: userId,
                name: data.name,
                userType: data.userType,
                groupId: data.groupId,
                menuIds: '',
                menuAppIds: '',
                groupIdName: '',
                userTypeName: ''
              }
              that.getGroup(data.userType)
              that.getMenu(data.userType)
              // if(data.userType==3||data.userType==5){
              //   that.getEnt('');
              // }else if(data.userType==4){
              //   that.getProject('');
              // } else if(data.userType==2){
              //   that.getSuperList('');
              // }
              // //web端
              // var tree = util.common.listToTree('id','parentId',resp.data.data.allMenus);
              // that.treeData = tree;
              // that.checkData = [];
              // for(var i=0;i<menu.length;i++){
              //   that.checkData.push(menu[i].id);
              // }
              // //APP端
              // var treeApp = util.common.listToTree('id','parentId',resp.data.data.allMenusApp);
              // that.treeApp = treeApp;
              // that.checkApp = [];
              // for(var i=0;i<menuApp.length;i++){
              //   that.checkApp.push(menuApp[i].id);
              // }
            } else {
              that.$message.error(resp.data.msg)
            }
          },
          function() {}
        )
    },
    //获取项目信息
    getGrounpName: function(id) {
      var list = this.groups
      var result = ''
      for (var i = 0; i < list.length; i++) {
        if (id == list[i].groupId) {
          result = list[i].groupName
        }
      }
      return result
    },
    //获取端名称
    getUserTypeName(id) {
      var list = this.userTypes
      var result = ''
      for (var i = 0; i < list.length; i++) {
        if (id == list[i].value) {
          result = list[i].label
        }
      }
      return result
    },
    // 删除数据
    handleDelete(index, row) {
      var that = this
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          myHttp
            .delRole({
              id: row.id
            })
            .then(
              function(resp) {
                if (resp.data.code == '200') {
                  that.$message({
                    type: 'success',
                    message: '删除成功!'
                  })
                  that.getData()
                } else {
                  that.$message.error(resp.data.msg)
                }
              },
              function() {}
            )
        })
        .catch(err => {
          that.$message({
            type: 'error',
            message: err
          })
        })
    },
    // 新增数据
    addRow() {
      this.addTitle = '新增角色'
      this.allMenuList = []
      this.allMenuApp = []
      this.groups = []
      this.checkData = []
      this.treeData = this.allMenuList
      this.checkApp = []
      this.treeApp = this.allMenuApp
      this.addFormVisible = true
      this.addForm = {
        id: '',
        name: '',
        userType: util.session.get('roleId'),
        groupId: this.groupId,
        menuIds: '',
        menuAppIds: '',
        groupIdName: '',
        userTypeName: ''
      }
      this.getGroup(this.addForm.userType)
      this.getMenu(this.addForm.userType)
    },
    // 将新增的数据添加到表格中
    sumbitAddRow(formName) {
      var that = this
      this.$refs[formName].validate(valid => {
        if (valid) {
          //web端
          var tree = this.$refs.tree.getCheckedNodes()
          var treeFather = this.$refs.tree.getHalfCheckedNodes()
          for (var i = 0; i < tree.length; i++) {
            if (i == 0) {
              this.addForm.menuIds = tree[i].id
            } else {
              this.addForm.menuIds += ',' + tree[i].id
            }
          }
          for (var j = 0; j < treeFather.length; j++) {
            if (this.addForm.menuIds != '') {
              this.addForm.menuIds += ',' + treeFather[j].id
            }
          }
          //app端
          var treeApp = this.$refs.app.getCheckedNodes()
          var treeFatherApp = this.$refs.app.getHalfCheckedNodes()
          for (var i = 0; i < treeApp.length; i++) {
            if (i == 0) {
              this.addForm.menuAppIds = treeApp[i].id
            } else {
              this.addForm.menuAppIds += ',' + treeApp[i].id
            }
          }
          for (var j = 0; j < treeFatherApp.length; j++) {
            if (this.addForm.menuAppIds != '') {
              this.addForm.menuAppIds += ',' + treeFatherApp[j].id
            }
          }
          this.addForm.userId = this.$store.state.user.id
          if (this.addForm.id == '') {
            myHttp.createRole(this.addForm).then(
              function(resp) {
                if (resp.data.code == '200') {
                  that.$message.success('添加角色成功')
                  that.addFormVisible = false
                  that.getData()
                } else {
                  that.$message.error(resp.data.msg)
                }
              },
              function() {}
            )
          } else {
            myHttp.modRole(this.addForm).then(
              function(resp) {
                if (resp.data.code == '200') {
                  that.$message.success('修改角色成功')
                  that.addFormVisible = false
                  that.getData()
                } else {
                  that.$message.error(resp.data.msg)
                }
              },
              function() {}
            )
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // cancel() {
    //   this.addFormVisible = false
    //   this.editFormVisible = false
    // },
    // 关闭弹出框弹窗
    handleClose(done) {
      this.addFormVisible = false
      // this.$confirm('确认关闭？')
      //   .then(_ => {
      //     done()
      //   })
      //   .catch(_ => {})
    },
    //人员配置
    handleUser(index, row) {
      this.editFormVisible = true
      this.addUser.roleId = row.id
      this.getUserRole()
    },
    //获取配置人员列表
    getUserRole() {
      var that = this
      myHttp
        .getUserListByRoleId({
          roleId: this.addUser.roleId
        })
        .then(
          function(resp) {
            if (resp.data.code == '200') {
              var list = resp.data.data.userList
              that.userData = list
            } else {
              that.$message.error(resp.data.msg)
            }
          },
          function() {}
        )
    },
    //根据username获取用户
    searchUser() {
      var that = this
      myHttp
        .getInfoByUsername({
          username: this.addUser.username
        })
        .then(
          function(resp) {
            if (resp.data.code == '200') {
              var data = resp.data.data.user
              if (data && data.id) {
                that.addUser.name = data.name
                that.addUser.id = data.id
                that.addUser.idcard = data.idcard
              } else {
                that.$message.error('该用户不存在，请先创建用户')
              }
            } else {
              that.$message.error(resp.data.msg)
            }
          },
          function() {}
        )
    },
    //打开添加用户
    addUserFun() {
      this.innerVisible = true
      this.addUser = {
        id: '',
        username: '',
        name: '',
        idcard: '',
        roleId: this.addUser.roleId
      }
    },
    //添加人员配置
    sumbitAddUser(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.addUser.id == '') {
            that.$message.error('该用户不存在，请先创建用户')
            return
          }
          var that = this
          this.addUser.userId = this.addUser.id
          myHttp.createRoleUser(this.addUser).then(
            function(resp) {
              if (resp.data.code == '200') {
                that.$message.success('配置用户成功')
                that.getUserRole()
                that.innerVisible = false
              } else {
                that.$message.error(resp.data.msg)
              }
            },
            function() {}
          )
        } else {
          // console.log('error submit!!')
          return false
        }
      })
      
    },
    //删除配置人员
    userDelete(index, row) {
      var that = this
      this.$confirm('此操作将删除数据关联, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          myHttp
            .deleteRoleUser({
              userId: row.id,
              roleId: that.addUser.roleId
            })
            .then(
              function(resp) {
                if (resp.data.code == '200') {
                  that.$message.success('操作成功')
                  that.getUserRole()
                } else {
                  that.$message.error('删除失败')
                }
              },
              function() {}
            )
        })
        .catch(err => {
          this.$message({
            type: 'error',
            message: err
          })
        })
    },
    //监听树形
    changeTree(e) {}
  }
}
</script>

<style>
@import '../../../assets/css/common.css';
</style>

<style scoped>
* {
  box-sizing: border-box;
}
.content {
  height: 100%;
  width: 100%;
  padding: 0 1vh;
}
.title{
    width: 100%;
    height: 3vh;
    position: relative;
    display: flex;
    align-content: center;
    align-items: center;
    padding-left: 1vw;
}
.build-CURD {
  width: 100%;
  height: calc( 100% - 3vh );
  position: relative;
  background: #fff;
}
.build-bar{
  padding: 0px 15px;
  height: 6vh;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  /* border-bottom: 1px solid #ddd; */
}
.build-table {
  height: calc(100% - 6.5vh);
  padding: 0 1vh;
}
.el-table >>> .cell {
  overflow: hidden;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
}

.build-bar >>> .btnLef {
  margin-left: 200px;
}

.el-form >>> .upload-demo {
  width: 220px;
  margin-bottom: 20px;
  margin-left: 100px;
}

.add-form >>> .el-upload-dragger {
  width: 100%;
  height: 100px;
}

.build-bar .add-user >>> span {
  text-align: center;
  margin-left: 2px;
}

.add-form .el-form-item {
  width: 80%;
}

.el-dropdown-link {
  cursor: pointer;
  color: #666;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.role-tree {
  overflow-y: scroll;
  min-height: 200px;
}
</style>

<style>
.add-form .el-select .el-input {
  width: 100%;
}
/* .el-table--border th, .el-table__fixed-right-patch{
        border-bottom: 1px solid #303133;
    }
    .el-table--border td, .el-table--border th, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed{
        border-right: 1px solid #303133;
    }
    .el-table td, .el-table th.is-leaf{
        border-bottom: 1px solid #303133;
    }
    .el-table--border, .el-table--group{
        border: 1px solid #303133;
    } */
</style>